import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import Lightbox from '../components/Lightbox';
import './Immigration.css';

const CyberSecurity = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({ src: '', alt: '' });

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage({ src: '', alt: '' });
  };

  return (
    <PageLayout 
      title="The Battle Tested Cyber Intelligence Platform" 
      subtitle="Delivery Insightful Protection With Unmatched Technological Depth - Combining AI-driven intelligence with real-time digital threat detection to proactively defend against phishing, data leaks, impersonation, and fraud across web, app, and social platforms."
    >
      <section className="immigration-section">
        <div className="container">
          <div className="immigration-intro">
            <h2>Next-Gen Cybersecurity Company</h2>
            <p>
              Rayad Group is a next-gen cybersecurity company that combines AI-driven intelligence with real-time digital threat detection. We empower organizations to proactively defend against phishing, data leaks, impersonation, and fraud across web, app, and social platforms.
            </p>
            
            <div className="capabilities-section" style={{marginTop: '32px'}}>
              <h3 style={{fontSize: '1.8rem', fontWeight: '700', marginBottom: '24px', color: '#1a1a1a', textAlign: 'center'}}>
                Core Cyber Intelligence Capabilities
              </h3>
              
              <div className="capabilities-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '24px', marginBottom: '32px'}}>
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1L9 7V9C9 10.1 9.9 11 11 11V16L12 15L13 16V11C14.1 11 15 10.1 15 9H21ZM7 23L12 18L17 23H7Z" fill="#495057"/>
                      <circle cx="12" cy="12" r="2" fill="#495057"/>
                      <path d="M12 8V12L15 15" stroke="#495057" strokeWidth="1.5" fill="none"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>Real-Time Threat Monitoring</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Continuous surveillance across social media, dark web, and digital platforms for emerging cyber threats</p>
                </div>
                
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 1L21.5 6.5V11.5C21.5 16.75 18.26 21.74 12 23C5.74 21.74 2.5 16.75 2.5 11.5V6.5L12 1ZM12 2.18L4 6.86V11.9C4 16.32 6.67 20.24 12 21.81C17.33 20.24 20 16.32 20 11.9V6.86L12 2.18ZM9.5 11L7 13.5L10 16.5L17 9.5L14.5 7L10 11.5L9.5 11Z" fill="#495057"/>
                      <circle cx="12" cy="10" r="2" fill="none" stroke="#495057" strokeWidth="1"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>AI-Powered Intelligence Detection</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Advanced machine learning algorithms for intelligent threat classification and automated response</p>
                </div>
                
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.8 10.9C9.53 10.31 8.8 9.7 8.8 8.75C8.8 7.66 9.81 6.9 11.5 6.9C13.28 6.9 13.94 7.75 14 9H16.21C16.14 7.28 15.09 5.7 13 5.19V3H10V5.16C8.06 5.58 6.5 6.84 6.5 8.77C6.5 11.08 8.41 12.23 11.2 12.9C13.7 13.5 14.2 14.38 14.2 15.31C14.2 16 13.71 17.1 11.5 17.1C9.44 17.1 8.63 16.18 8.5 15H6.32C6.44 17.19 8.08 18.42 10 18.83V21H13V18.85C14.95 18.5 16.5 17.35 16.5 15.3C16.5 12.46 14.07 11.5 11.8 10.9Z" fill="#495057"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>Financial Threat Intelligence</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Comprehensive financial crime detection with regulatory compliance and transaction monitoring</p>
                </div>
                
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16 4V2C16 1.45 15.55 1 15 1H9C8.45 1 8 1.45 8 2V4C6.9 4 6 4.9 6 6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V6C18 4.9 17.1 4 16 4ZM10 3H14V4H10V3ZM16 19H8V6H16V19Z" fill="#495057"/>
                      <circle cx="12" cy="10" r="2" fill="none" stroke="#495057" strokeWidth="1"/>
                      <path d="M9 14H15M9 16H15" stroke="#495057" strokeWidth="1"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>Social Media Profiling Systems</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Ethical vetting systems with behavioral analysis and risk assessment capabilities</p>
                </div>
                
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 3C7.58 3 4 4.79 4 7V17C4 19.21 7.58 21 12 21S20 19.21 20 17V7C20 4.79 16.42 3 12 3ZM18 17C18 17.5 15.87 19 12 19S6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16S16.39 15.55 18 14.77V17ZM18 12.45C16.7 13.4 14.42 14 12 14C9.58 14 7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11C14.39 11 16.53 10.47 18 9.64V12.45ZM12 9C8.13 9 6 7.5 6 7S8.13 5 12 5S18 6.5 18 7S15.87 9 12 9Z" fill="#495057"/>
                      <path d="M12 6V8M10 7H14" stroke="white" strokeWidth="1"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>Database Leak Detection</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Proactive scanning for unauthorized data exposures with real-time alerting and mitigation</p>
                </div>
                
                <div className="capability-card" style={{background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease'}}>
                  <div className="capability-icon" style={{marginBottom: '12px'}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 2ZM12 4.18L5 6.3V11.22C5 15.54 8.07 19.43 12 20.81C15.93 19.43 19 15.54 19 11.22V6.3L12 4.18Z" fill="#495057"/>
                      <path d="M8 12L11 15L16 9" stroke="#495057" strokeWidth="2" fill="none"/>
                    </svg>
                  </div>
                  <h4 style={{fontSize: '1.2rem', fontWeight: '600', marginBottom: '8px', color: '#495057'}}>Brand Protection & Mitigation</h4>
                  <p style={{fontSize: '0.95rem', color: '#6c757d', lineHeight: '1.5', margin: 0}}>Comprehensive brand reputation monitoring with impersonation detection and response controls</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="tab-content">
            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Real-Time Threat Monitoring</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Scans social media, dark web, and other platforms for cyber threats. Continuously monitors various online sources to detect emerging cyber threats in real time.
                  </p>
                  
                  <div className="info-section">
                    <h4>Social Media Threat Detection</h4>
                    <ul>
                      <li>Identifies threats on Facebook, Twitter, Instagram, YouTube, Telegram, etc.</li>
                      <li>Monitors multiple social media platforms to detect cyber threats and malicious activity</li>
                      <li>Real-time social media surveillance and threat identification</li>
                      <li>Cross-platform threat correlation and analysis</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Dark Web & Platform Monitoring</h4>
                    <ul>
                      <li>Dark web scanning for cyber threats and malicious activity</li>
                      <li>Emerging threat detection across digital ecosystems</li>
                      <li>Real-time intelligence gathering from multiple online sources</li>
                      <li>Continuous threat landscape surveillance</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Advanced Detection Capabilities</h4>
                    <ul>
                      <li>AI-powered threat classification and alerting</li>
                      <li>Multi-platform threat correlation and analysis</li>
                      <li>Automated threat prioritization systems</li>
                      <li>Real-time threat intelligence feeds</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/real_time_threat_monitoring.png" 
                    alt="Real-Time Threat Monitoring" 
                    onClick={() => openLightbox('/images/real_time_threat_monitoring.png', 'Real-Time Threat Monitoring')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Financial Threat Intelligence</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We are a single window financial threat intelligence company which provides cutting edge AI & ML based solutions for securing your businesses from threats. Winners of the 1st Regtech Challenge supported by RBI & SEBI. Recognized by IFSCA with Limited Use Authorization in 2024.
                  </p>
                  
                  <div className="info-section">
                    <h4>Screening Solution for Regulators</h4>
                    <ul>
                      <li>Advanced machine learning models based screening solutions</li>
                      <li>Sanction regimes and blacklist check for members</li>
                      <li>Low false positive rates with constantly updated models</li>
                      <li>High-speed APIs with wider coverage of multiple jurisdictions</li>
                      <li>Highly accurate adverse media coverage from more than 1200 sources across the world</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Transaction Monitoring for Regulators</h4>
                    <ul>
                      <li>We utilize the latest developments in the Graph Neural Networks and Advanced Generative AI</li>
                      <li>Improve the accuracy of detection of high risk accounts in the transactions by identification of Money Mules or International Money Laundering Rings</li>
                      <li>Our Generative AI solutions based on highly customized Large Language models will reduce the compliance time and cost</li>
                      <li>Generating quick summaries for the accounts under observation for further dissemination</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/financial_threat_intelligence.png" 
                    alt="Financial Threat Intelligence" 
                    onClick={() => openLightbox('/images/financial_threat_intelligence.png', 'Financial Threat Intelligence')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Threat Analytics & Frequency Tracking</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Analyzes threat data to reveal trends, frequencies, and severity levels for proactive security measure.
                  </p>
                  
                  <div className="info-section">
                    <h4>Brand Protection</h4>
                    <ul>
                      <li>Detects online impersonation and phishing activities that may compromise brand reputation</li>
                      <li>Comprehensive brand reputation protection across digital platforms</li>
                      <li>Executive impersonation and brand abuse monitoring</li>
                      <li>Proactive brand threat identification and mitigation</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Fake News & Misinformation Detection</h4>
                    <ul>
                      <li>Uses advanced algorithms to detect and flag fake or misleading news that could affect reputation</li>
                      <li>Reputation damage prevention through misinformation monitoring</li>
                      <li>Advanced content verification and fact-checking capabilities</li>
                      <li>Real-time misinformation tracking across media platforms</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/threat_analytics_frequency_tracking.png" 
                    alt="Threat Analytics" 
                    onClick={() => openLightbox('/images/threat_analytics_frequency_tracking.png', 'Threat Analytics')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Social Media Profiling System</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Intelligent, ethical, risk-aware vetting system for visa processing and security applications. Enhance U.S. visa application vetting using publicly available social media content to detect behavioral red flags, inconsistencies, or fraudulent claims.
                  </p>
                  
                  <div className="info-section">
                    <h4>Key Profiling Indicators</h4>
                    <ul>
                      <li>Identity and Consistency Analysis: Name, photo, and location matching across platforms</li>
                      <li>Behavioral Traits Analysis: Content labeling using Advanced NLP models</li>
                      <li>Social Network & Affiliations: Connections to suspicious accounts/groups</li>
                      <li>Location and Travel History: Geo-tagged posts consistency verification</li>
                      <li>Professional and Academic Verification: Cross-verification of credentials</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Advanced Technical Approach</h4>
                    <ul>
                      <li>Text Analysis using NLP libraries: spaCy, Hugging Face Transformers</li>
                      <li>Image & Video Analysis: Deep learning (YOLOv8, CLIP) for content detection</li>
                      <li>Behavioral Modelling: Time series models for posting patterns</li>
                      <li>Graph Analysis for Social Network: Neo4j for graph storage</li>
                      <li>Risk Scoring & Decision Engine with weighted aggregation</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/social_media_profiling_system.png" 
                    alt="Social Media Profiling" 
                    onClick={() => openLightbox('/images/social_media_profiling_system.png', 'Social Media Profiling')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Database Leak Detection & Threat Mitigation</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Scans internal and external databases to identify unauthorized data exposures and alerts organizations about leaked sensitive data. Provides control options for responding to detected threats, enabling swift mitigation.
                  </p>
                  
                  <div className="info-section">
                    <h4>Database Security Services</h4>
                    <ul>
                      <li>Internal and external database scanning for unauthorized exposures</li>
                      <li>Sensitive data leak identification and alerting</li>
                      <li>Real-time data exposure monitoring across multiple sources</li>
                      <li>Comprehensive data breach detection and notification</li>
                      <li>Proactive database vulnerability assessment</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Threat Mitigation Actions</h4>
                    <ul>
                      <li>Allows users to whitelist, take down, or request deep analysis of threats</li>
                      <li>Provides control options for responding to detected threats, enabling swift mitigation</li>
                      <li>Automated threat response and containment capabilities</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Threat Export & Reporting</h4>
                    <ul>
                      <li>Enables exporting threat reports in JSON and Excel formats for sharing and further analysis</li>
                      <li>Comprehensive reporting capabilities for threat intelligence dissemination</li>
                      <li>Detailed threat analysis documentation and case file generation</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/database_leak_detection_threat_mitigation.png" 
                    alt="Database Security" 
                    onClick={() => openLightbox('/images/database_leak_detection_threat_mitigation.png', 'Database Security')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Cyber Threat Intelligence & LEA Integration</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Our platform smoothly integrates with the cyber threat intelligence collected from the proprietary external platforms to cover the key threats such as customer care frauds, money launderers, fake recruitment scammers and other similar threats through active collection and scanning of the user records for risk categorization.
                  </p>
                  
                  <div className="info-section">
                    <h4>Threat Coverage & Integration</h4>
                    <ul>
                      <li>Customer care frauds detection and prevention</li>
                      <li>Money launderers identification and tracking</li>
                      <li>Fake recruitment scammers monitoring</li>
                      <li>Active collection and scanning of user records for risk categorization</li>
                      <li>Integration with proprietary external threat intelligence platforms</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Compliance & Regulatory Support</h4>
                    <ul>
                      <li>Tracking records and compliance issues from regulators</li>
                      <li>Separate dashboard for regulatory compliance monitoring</li>
                      <li>Alerts about notifications issued by regulatory authorities</li>
                      <li>Real-time compliance status tracking and reporting</li>
                      <li>Automated regulatory notification management</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/cyber_threat_intelligence_lea_integration.png" 
                    alt="LEA Integration" 
                    onClick={() => openLightbox('/images/cyber_threat_intelligence_lea_integration.png', 'LEA Integration')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="immigration-service-card">
            <div className="service-header">
              <h3>Why Choose Rayad Group?</h3>
            </div>
            <div className="service-content">
              <div className="service-text">
                <p style={{fontSize: '1.1rem', marginBottom: '30px'}}>
                  We deliver comprehensive cybersecurity solutions that combine cutting-edge AI technology, machine learning algorithms, and human expertise to provide real-time protection against sophisticated digital threats with proven industry recognition.
                </p>
                
                <div className="info-section">
                  <h4>Certified Cybersecurity Professionals</h4>
                  <p>24/7 Monitoring with AI-Powered Real-Time Detection Across Digital Ecosystems</p>
                </div>
                
                <div className="info-section">
                  <h4>Plug-and-Play Integrations</h4>
                  <p>API-Ready Modules with End-to-End Protection and Tailored Solutions</p>
                </div>
                
                <div className="info-section">
                  <h4>Industry Recognition & Awards</h4>
                  <p>Winners of the 1st Regtech Challenge supported by RBI & SEBI. Recognized by IFSCA with Limited Use Authorization in 2024. Proven Impact on BFSI, Fintech, Public Sector, and Enterprise Environments.</p>
                </div>
                
                <div className="info-section">
                  <h4>Dedicated Partnership Model</h4>
                  <p>Joint Go-To-Market Potential with Affordable, Scalable Solutions</p>
                </div>
                
                <div style={{marginTop: '32px', padding: '24px', background: 'rgba(0,0,0,0.05)', borderRadius: '12px'}}>
                  <p style={{margin: '0', fontSize: '1rem', lineHeight: '1.6', fontStyle: 'italic'}}>
                    Security without limits. Intelligence without boundaries. Our battle-tested cyber intelligence platform delivers insightful protection with unmatched technological depth, combining AI-driven intelligence with real-time digital threat detection.
                  </p>
                </div>
              </div>
              <div className="service-image">
                <img 
                  src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                  alt="Cybersecurity Excellence" 
                  onClick={() => openLightbox('https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Cybersecurity Excellence')}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
          </div>
          
          <div className="immigration-page-cta-section">
            <h3>Secure Your Digital Assets</h3>
            <p>Ready to deploy comprehensive cyber threat intelligence? Contact our cybersecurity specialists to explore our battle-tested platform.</p>
            <a href="/contact" className="btn immigration-btn-primary">Get Cyber Protection</a>
          </div>
        </div>
      </section>
      <Lightbox 
        isOpen={lightboxOpen}
        imageSrc={lightboxImage.src}
        imageAlt={lightboxImage.alt}
        onClose={closeLightbox}
      />
    </PageLayout>
  );
};

export default CyberSecurity;